import { render, staticRenderFns } from "./productDetailLabel.vue?vue&type=template&id=10c1ffd6&scoped=true"
import script from "./productDetailLabel.vue?vue&type=script&lang=js"
export * from "./productDetailLabel.vue?vue&type=script&lang=js"
import style0 from "./productDetailLabel.vue?vue&type=style&index=0&id=10c1ffd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1ffd6",
  null
  
)

export default component.exports